<template>
  <div>
    <el-dialog
      title="添加农产品"
      :visible.sync="showFlag"
      width="30%"
      center
      :close-on-click-modal="false"
      :before-close="closeModal"
    >
      <div class="Form">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="产品名称" prop="goodsName">
            <el-input
              v-model="ruleForm.goodsName"
              class="product_input"
              maxlength="20"
              placeholder="请输入产品名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="产品种类" prop="type">
            <el-select
              filterable
              v-model="ruleForm.type"
              placeholder="请选择产品种类"
              @change="getCropDetail"
            >
              <el-option
                v-for="item in goodsLevelList"
                :key="item.key"
                :label="item.name"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品图片">
            <div class="img-list">
              <div class="img-list-item" v-if="ruleForm.imgUrl">
                <el-image
                  :src="ruleForm.imgUrl"
                  :preview-src-list="[ruleForm.imgUrl]"
                />
                <i class="el-icon-error" @click="removeImg"></i>
              </div>
              <el-upload
                v-if="!ruleForm.imgUrl"
                class="upload-img"
                :action="uploadAction"
                accept="image/jpg,image/jpeg,image/png,image/bmp,image/webp"
                :show-file-list="false"
                :on-change="handleFileChange"
                :auto-upload="false"
                :on-error="handleError"
                v-loading="uploading"
              >
                <div class="img-add">
                  <i class="el-icon-plus"></i>
                  上传图片
                </div>
              </el-upload>
            </div>
          </el-form-item>

          <div class="submit_wrap">
            <el-button type="primary" @click="submitForm('ruleForm')"
              >保 存</el-button
            >
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { snkd } from "@/api/api";
import { v4 as uuidv4 } from "uuid";
import { getCrop, addCrop } from "@/api/request/snkd.produce";
import { upload } from "@/api/request/snkd.foundation";
import { getStorage } from "@/utils/storage";
export default {
  props: {
    showFlag: {
      type: Boolean,
      default: true,
    },
    cropId: {
      type: Number,
      default: 0,
    },
    cropName: {
      type: String,
      default: "",
    },
  },
  watch: {
    cropName: {
      handler(val) {
        if (val) {
          // this.getCropList();
          this.goodsLevelList = [
            {
              name: val,
              key: 1,
            },
          ];
          console.log("this.goodsLevelList", val, this.goodsLevelList);
        }
      },
      immediate: true,
      deep: true,
    },
  },

  data() {
    return {
      companyId: "",
      farmId: "",
      uploadAction: snkd.foundation.file.upload,
      uploading: false,
      dialogVisible: false,
      goodsLevelList: [],
      ruleForm: {
        goodsName: "",
        type: "",
        imgUrl: "",
      },
      rules: {
        goodsName: [
          { required: true, message: "请输入产品名称", trigger: "change" },
        ],
        type: [
          { required: true, message: "请选择产品种类", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    //获取农场id
    const farminfo = getStorage("FARMINFO");
    if (getStorage("FARMINFO")) {
      this.companyId = farminfo.companyId;
      this.farmId = farminfo.farmId;
    }
  },
  methods: {
    //表单提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addCrop();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async addCrop() {
      await addCrop({
        ...this.ruleForm,
        companyId: this.companyId,
        farmId: this.farmId,
        cropId: this.cropId,
      }).then((res) => {
        const { respCode, obj } = res;
        if (respCode === 0) {
          this.$message({
            message: "新增成功",
            type: "success",
          });
          this.$emit("update:showFlag", false);
          this.$emit("updateProductList");
          this.$emit("updateProductId", obj.id);
          this.resetForm();
        }
      });
    },
    async getCropDetail() {
      await getCrop({
        companyId: this.companyId,
        id: this.cropId,
        farmId: this.farmId,
      }).then((res) => {
        const { respCode, obj } = res;
        console.log(respCode, obj);
        if (respCode === 0) {
          this.ruleForm.imgUrl = obj.imgUrl;
        }
      });
    },
    //关闭弹窗
    closeModal() {
      this.$emit("update:showFlag", false);
      this.resetForm();
    },

    //重置表单
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    async handleFileChange(file) {
      this.uploading = true;
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("图片上传大小不超过10MB");
        return false;
      }
      await this.submitFileForm(file);
    },
    // 提交上传文件
    async submitFileForm(file) {
      let formData = new FormData();
      const dir = "snkoudai/web/";
      const fileType = file.raw["type"];
      const index = fileType.lastIndexOf("/") + 1;
      const fileFormat = fileType.substring(index, fileType.length);
      var fileName = `${uuidv4()}.${fileFormat}`;
      formData.append("file", file.raw);
      formData.append("folderPath", dir);
      formData.append("originalFilename", fileName);
      this.uploading = true;
      await upload(formData)
        .then((res) => {
          const uploadRet = res && res.obj && res.obj.internetUrl;
          if (!uploadRet) return;
          this.ruleForm.imgUrl = res.obj.internetUrl;
          this.uploading = false;
        })
        .catch(() => {
          this.$message.error("上传失败！");
          this.uploading = false;
        });
    },
    handleError(err) {
      console.log("handleError", err);
      this.uploading = false;
    },
    removeImg() {
      this.ruleForm.imgUrl = "";
    },
  },
};
</script>

<style scoped lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.submit_wrap {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  button {
    margin-top: 20px;
    width: 110px;
  }
}
.el-select {
  width: 100%;
}
.img-list {
  display: flex;
  &-item {
    position: relative;
    line-height: 1;
    ::v-deep .el-image {
      width: 100px;
      height: 100px;
      border-radius: 4px;
      margin-right: 10px;
    }
    .el-icon-error {
      position: absolute;
      right: 2px;
      top: -8px;
      font-size: 18px;
      background-color: #fff;
      border-radius: 50%;
      color: #dadada;
      box-sizing: border-box;
      cursor: pointer;
    }
  }
}
.upload-img {
  ::v-deep .el-upload {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 100px;
    height: 100px;
    cursor: pointer;
    line-height: 98px;
    vertical-align: top;
    color: #8c939d;
  }
}
</style>
